import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import { Component } from "@/decorators";
import ProdutoDciModel from "@/models/produto/produtoDciModel";
import produtoDciService from "@/services/produto/produtoDciService";

import ListComponentBase from "../listComponentBase";

@Component
export default class ProdutoDciListComponent extends ListComponentBase<ProdutoDciModel> {
    get gridColumns(): Array<GridColumn> {
        return [
            new GridColumn("codigo", this.$t("__.ts.codigo"), GridColumnType.String),
            new GridColumn("descricao", this.$t("__.ts.descricao"), GridColumnType.String),
        ];
    }

    private beforeMount() {
        this.setPropsCached(produtoDciService, "produtodci", "descricao");
    }
}
